import {
    GET_GROUPS_URL,
    CREATE_PAYEE_URL,
    GET_ALL_PAYEE_URL,
    TOGGLE_PAYEE_URL,
    GET_ROLES_URL,
    DELETE_GROUP_URL,
    CREATE_GROUPS_URL,
    CREATE_ROLES_URL,
    GET_PERMISSIONS_URL,
    GET_SINGLE_PAYEE_DETAIL_URL,
    GET_ALL_PAYER_URL,
    CREATE_PAYER_URL,
    TOGGLE_PAYER_URL,
    GET_SINGLE_PAYER_DETAIL_URL,
    CREATE_USER_URL,
    GET_ALL_USER_URL,
    TOGGLE_USER_URL,
    DELETE_ROLES_URL,
    GET_SINGLE_USER_DETAIL_URL,
    GET_GROUPS_FOR_USER_URL,
    GET_GROUP_DETAILS_URL,
    GET_SINGLE_ROLE_DETAIL_URL,
    GET_REASON_CODES_URL,
    CREATE_REASON_CODES_URL,
    GET_X12_CODES_URL,
    CREATE_X12_CODE_URL,
    TOGGLE_X12_CODE_URL,
    GET_CORRESPONDENCE_CATEGORY,
    GET_X12_CODE_DROPDOWN_URL,
    CREATE_CORRESPONDENCE_CATEGORY,
    GET_PAYER_DROPDOWN,
    GET_PAYER_DROPDOWN_V2,
    DELETE_REASON_CODES_URL,
    GET_SINGLE_X12_CODE_DROPDOWN_URL,
    DELETE_CORRESPONDENCE_CATEGORY,
    GET_SINGLE_REASON_CODE_URL,
    GET_SINGLE_CORRESPONDENCE_CATEGORY,
    GET_ALL_SETTINGS_URL,
    UPDATE_SETTINGS_URL,
    GET_ALL_TIMEZONE,
    GET_CLIENTS_PDF_URL,
    POST_PROP_CODE_CREATE_URL,
    GET_ROLES_DROPDOWN_URL,
    GET_REASON_CODE_CSV_IMPORT_URL,
    GET_PAYER_CSV_IMPORT_URL,
    GET_PAYEE_CSV_IMPORT_URL,
    GET_CLIENT_FACILITY_URL,
    GET_USER_CSV_IMPORT_URL,
    GET_SELECTED_TIMEZONE,
    GET_PAYER_DEFFERENCE_REPORT_URL,
    EXPORT_PAYEE_URL,
    EXPORT_PAYER_URL,
    EXPORT_REASON_CODES_URL,
    GET_DEFAULT_PAYEE_PAYER_URL,
    CREATE_PAYER_ID_LIST_URL,
    DELETE_PAYER_ID_LIST_URL,
    GET_SINGLE_PAYER_ID_LIST_DETAIL_URL,
    GET_ALL_PAYER_ID_LIST_URL,
    GET_PAYER_ID_LIST_CSV_IMPORT_URL,
    EXPORT_PAYER_ID_LIST_URL,
    GET_PAYEE_DEFFERENCE_REPORT_URL,
    GET_ALL_SETTINGS_DROP_DOWN_URL,
    GET_X12_CSV_IMPORT_URL,
    GET_FAILED_JOBS_XAUTO,
    GET_REASON_CODES_ACTIVE,
    GET_SETTINGS_LOG_URL,
    GET_REASON_CODES_LOG,
    USER_WISE_REPORT_LIST_URL,
    TOGGLE_PAYER_ID_LIST_URL,
    GET_CORRESPONDENCE_LOG,
    GET_CORRESPONDENCE_ACTIVE_INACTIVE,
    AUTOMATION_USER,
    ENABLE_OR_DISABLE_AUTOMATION_USER,
    AUTOMATION_USER_DETAIL,
    GET_SINGLE_PAYEE_DETAIL_FROM_GRID_URL,
    GET_SINGLE_PAYER_DETAIL_FROM_GRID_URL,
    GET_FAILED_JOBS_XAUTO_V2,
    RELEASE_PAYER_URL,
    RELEASE_SINGLE_PAYER_URL,
    RELEASE_PAYEE_URL,
    RELEASE_SINGLE_PAYEE_URL,
    GET_PAYER_IDENTIFICATION_CODE_URL
} from './../../api/index';
import axiosInstance from '../../axiosInstance';
import moment from 'moment';
import { CREATE_AUTOMATION_USER, EDIT_AUTOMATION_USER, KEEP_ALIVE } from '../../routeNames';


export const getGroups = (props) => onResponse => {
    try {
        let data = props.search ? props.search : ''
        axiosInstance.get(GET_GROUPS_URL, {
            params: {
                page: props.page,
                limit: props.limit,
                search: data
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAutomationUser = (props) => onResponse => {
    try {
        let data = props.search ? props.search : ''
        axiosInstance.get(AUTOMATION_USER, {
            params: {
                page: props.page,
                limit: props.limit,
                search: data,
                is_active: props.is_active || "",
                users: props.user || "",
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const createAutomationUser = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_AUTOMATION_USER, props.data)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                // console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }
};

export const editAutomationUser = (data) => onResponse => {
    try {
        axiosInstance.post(EDIT_AUTOMATION_USER, data)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }
};

export const getSingleAutomationUserDetails = (id) => (onResponse) => {
    axiosInstance
        .get(AUTOMATION_USER_DETAIL, {
            params: {
                id
            }
        })
        .then(res => onResponse(res.data))
        .catch(err => {
            console.log(err);
            onResponse(err);
        });
};


export const enableAutomationUser = (id) => (onResponse) => {
    axiosInstance
        .post(ENABLE_OR_DISABLE_AUTOMATION_USER, {
            id
        })
        .then(res => onResponse(res.data))
        .catch(err => {
            console.log(err);
            onResponse(err);
        });
};


export const createGroup = (name, roles, reference_number, comments) => onResponse => {
    try {


        axiosInstance.post(CREATE_GROUPS_URL, {
            name: name,
            roles: roles,
            reference_number: reference_number,
            comments: comments

        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const editGroup = (id, name, roles, reference_number, comments) => onResponse => {
    try {


        axiosInstance.post(CREATE_GROUPS_URL, {
            group: id,
            name: name,
            roles: roles,
            reference_number: reference_number,
            comments: comments

        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const deleteGroup = (group_id, reference_number, comments) => onResponse => {
    // console.log(props, 'trgreretry')
    try {
        axiosInstance.delete(DELETE_GROUP_URL, {
            data: { group: group_id, reference_number, comments }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


// payee Managment
export const createPayee = (props) => onResponse => {
    // console.log(props);
    try {
        axiosInstance.post(CREATE_PAYEE_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                // console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getPayerPayeeDefaultvalue = (props) => onResponse => {
    try {
        axiosInstance.get(GET_DEFAULT_PAYEE_PAYER_URL + "?client=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSinglePayerDetailsFromGrid = (props) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_PAYER_DETAIL_FROM_GRID_URL + "?payer_id=" + props?.payerId + "&job_id=" + props?.jobId)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAllPayees = (props) => onResponse => {
    
    try {
        const data = props.search ? props.search : ''
        const approve = props.status ? props.status : ''
        const updated_date_range = props.updated_date_range ? props.updated_date_range : ""
        const sort_key = props.sort_key ? props.sort_key : ""
        const sort_order = props.sort_order ? props.sort_order : ""
        const data_from = props.data_from ? props.data_from : ""
        const lockbox_name = props.lockbox_name ? props.lockbox_name : ""
        const clients = props.clients ? props.clients : []
        const edit_status =props.edit_status ? props.edit_status:""
        const partner = props.partner ? props.partner : []
        const active_status = props.active_status ? props.active_status : ""
        axiosInstance.get(GET_ALL_PAYEE_URL, {
            params: {
                page: props.page,
                limit: props.limit,
                search: data,
                is_approved: approve,
                updated_date_range: updated_date_range,
                clients: clients.join(','),
                data_from: data_from,
                sort_order: sort_order,
                sort_key: sort_key,
                lbx_file_name: lockbox_name,
                edit_status:edit_status,
                partner: partner.join(','),
                active_status: active_status,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const exportAllPayees = (props) => onResponse => {
    try {
        const data = props.search ? props.search : ''
        const approve = props.status ? props.status : ''
        const updated_date_range = props.updated_date_range ? props.updated_date_range : ""
        const sort_key = props.sort_key ? props.sort_key : ""
        const sort_order = props.sort_order ? props.sort_order : ""
        const clients = props.clients ? props.clients : []
        const data_from = props.data_from ? props.data_from : ""
        const lockbox_name = props.lockbox_name ? props.lockbox_name : ""
        const edit_status =props.edit_status ? props.edit_status:""
        const partner = props.partner ? props.partner : []
        const active_status = props.active_status ? props.active_status : ""


        axiosInstance.get(EXPORT_PAYEE_URL + '?search=' + data + '&is_approved=' + approve + '&updated_date_range=' + updated_date_range + '&clients=' + clients + '&data_from=' + data_from + '&sort_order=' + sort_order + '&sort_key=' + sort_key + '&lbx_file_name=' + lockbox_name + '&edit_status=' + edit_status + '&partner=' + partner + '&active_status=' + active_status)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
    }

};

export const togglePayee = (props) => onResponse => {
    try {
        axiosInstance.put(TOGGLE_PAYEE_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const payeeDifferenceReport = (props) => onResponse => {
    try {
        axiosInstance.get(GET_PAYEE_DEFFERENCE_REPORT_URL + "?payee=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSinglePayeeDetails = (props) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_PAYEE_DETAIL_URL + "?payee=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};
export const releasePayee = (payee_ids, reason) => onResponse => {
    try {
        axiosInstance.post(RELEASE_PAYEE_URL, { payee_ids: payee_ids.toString(), comment: reason })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const releaseSinglePayee = (payee) => onResponse => {
    try {
        axiosInstance.post(RELEASE_SINGLE_PAYEE_URL, { payee: payee })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSinglePayeeDetailsFromGrid = (props) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_PAYEE_DETAIL_FROM_GRID_URL + "?payee_id=" + props?.payeeId + "&job_id=" + props?.jobId)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};

// user Managment
export const createUser = (props) => onResponse => {
    console.log(props?.group_data);
    // try {
    // if (props?.values?.password) {

    axiosInstance.post(CREATE_USER_URL, {
        user: props?.values?.user ? props?.values?.user : "",
        username: props?.values?.username,
        name: props?.values?.name == "" || props?.values?.name === null ? "" : props?.values?.name,
        email: props?.values?.email == "" || props?.values?.email === null ? "" : props?.values?.email,
        date_of_birth: props?.values?.date_of_birth == "" || props?.values?.date_of_birth === null ? '' : moment(props?.values?.date_of_birth).format("YYYY-MM-DD"),
        emp_id: props?.values?.emp_id == "" || props?.values?.emp_id === null ? '' : props?.values?.emp_id,
        password: props?.values?.password == "" || props?.values?.password === null ? undefined : props?.values?.password,
        is_superuser_dashboard: props?.values?.is_admin_dashboard,

        groups: props?.group_data,
        reference_number: props?.values?.reference_number,
        comments: props?.values?.comments || props?.values?.comments,
    })
        .then((response) => {
            // console.log(response)
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err)
            onResponse(err);
        });

    // }
    // else {
    //     axiosInstance.post(CREATE_USER_URL, {
    //         user: props?.values?.user ? props?.values?.user : "",
    //         username: props?.values?.username,
    //         email: props?.values?.email == "" || props?.values?.email === null ?undefined:props?.values?.email,
    //         name: props?.values?.name == "" || props?.values?.name === null ?undefined:props?.values?.name,
    //         emp_id: props?.values?.emp_id == "" || props?.values?.emp_id === null ?undefined:props?.values?.emp_id,
    //         groups: props?.group_data,
    //         is_active: true
    //     })
    //         .then((response) => {
    //             // console.log(response)
    //             onResponse(response.data);
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //             onResponse(err);
    //         });
    // }
    // } catch (error) {

    // }

};

export const getAllUsers = (props) => onResponse => {
    try {
        let data = props.search ? props.search : ''
        axiosInstance.get(GET_ALL_USER_URL, {
            params: {
                page: props.page,
                limit: props.limit,
                search: data
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};



export const toggleUser = (props) => onResponse => {
    try {
        axiosInstance.put(TOGGLE_USER_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const importCsvUserCode = (props) => onResponse => {
    try {
        // console.log(csv_file);
        axiosInstance.post(GET_USER_CSV_IMPORT_URL, props.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSingleUserDetails = (props) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_USER_DETAIL_URL + "?user=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSingleGroupDetails = (props) => onResponse => {
    try {
        axiosInstance.get(GET_GROUP_DETAILS_URL + "?group=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getRoles = (props) => onResponse => {
    // console.log(props);
    try {
        let data = props.search ? props.search : ''
        axiosInstance.get(GET_ROLES_URL, {
            params: {
                page: props.page,
                limit: props.limit,
                search: data
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getRolesDropdown = () => onResponse => {
    // console.log(props);
    try {
        axiosInstance.get(GET_ROLES_DROPDOWN_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};




// payer Managment
export const createPayer = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_PAYER_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getPayerIdentificationCode = (payer_id, is_force_process = false) => onResponse => {
    try {
        axiosInstance.post(GET_PAYER_IDENTIFICATION_CODE_URL, { payer_id, is_force_process })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAllPayers = (props) => onResponse => {
    try {
        let data = props.search ? props.search : ''
        let approve = props.status ? props.status : ""
        const updated_date_range = props.updated_date_range ? props.updated_date_range : ""
        const sort_key = props.sort_key ? props.sort_key : ""
        const sort_order = props.sort_order ? props.sort_order : ""
        const clients = props.clients ? props.clients : []
        const data_from = props.data_from ? props.data_from : ""
        const lockbox_name = props.lockbox_name ? props.lockbox_name : ""
        const payer_availity_status = props.payer_availity_status ? props.payer_availity_status : ""
        const is_auto_approved = props.is_auto_approved ? props.is_auto_approved : ""
        const partner = props.partner ? props.partner :[]
        const active_status = props.active_status ? props.active_status : ""
        const payer_identification = props.payer_identification ? props.payer_identification : ""
        const edit_status =props.edit_status ? props.edit_status:""

        axiosInstance.get(GET_ALL_PAYER_URL, {
            params: {
                page: props.page,
                limit: props.limit,
                search: data,
                is_approved: approve,
                updated_date_range: updated_date_range,
                clients: clients.join(","),
                data_from: data_from,
                sort_order: sort_order,
                sort_key: sort_key,
                lbx_file_name: lockbox_name,
                payer_availity_status: payer_availity_status,
                is_auto_approved: is_auto_approved,
                partner: partner.join(","),
                active_status: active_status,
                payer_identification: payer_identification,
                edit_status:edit_status

            }
        })

            .then((response) => {
                console.log(response.data.data)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
    }

};
export const exportAllPayers = (props) => onResponse => {
    try {
        let data = props.search ? props.search : ''
        let approve = props.status ? props.status : ""
        const updated_date_range = props.updated_date_range ? props.updated_date_range : ""
        const sort_key = props.sort_key ? props.sort_key : ""
        const sort_order = props.sort_order ? props.sort_order : ""
        const clients = props.clients ? props.clients : []
        const data_from = props.data_from ? props.data_from : []
        const lockbox_name = props.lockbox_name ? props.lockbox_name : ""
        const payer_availity_status = props.payer_availity_status ? props.payer_availity_status : ""
        const is_auto_approved = props.is_auto_approved ? props.is_auto_approved : ""
        const partner = props.partner ? props.partner :[]
        const active_status = props.active_status ? props.active_status : ""
        const payer_identification = props.payer_identification ? props.payer_identification : ""
        const edit_status =props.edit_status ? props.edit_status:""



        axiosInstance.get(EXPORT_PAYER_URL + "?page=" + props.page + "&limit=" + props.limit + '&search=' + data + '&is_approved=' + approve + '&updated_date_range=' + updated_date_range + '&clients=' + clients + '&data_from=' + data_from + '&sort_order=' + sort_order + '&sort_key=' + sort_key + '&lbx_file_name=' + lockbox_name + '&payer_availity_status=' + payer_availity_status + '&is_auto_approved=' + is_auto_approved + '&active_status=' + active_status + '&payer_identification=' + payer_identification + '&edit_status=' + edit_status +'&partner='+ partner)
            .then((response) => {
                console.log(response.data.data)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const payerDifferenceReport = (props) => onResponse => {
    try {
        axiosInstance.get(GET_PAYER_DEFFERENCE_REPORT_URL + "?payer=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const togglePayer = (props) => onResponse => {
    try {
        axiosInstance.put(TOGGLE_PAYER_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSinglePayerDetails = (props) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_PAYER_DETAIL_URL + "?payer=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};
 export const getRealsePayer = (payer,reason) => onResponse => {
    try {
        axiosInstance
            .post(RELEASE_PAYER_URL, {payer:payer.toString(),comment:reason})
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) {
    }
};

 export const releaseSinglePayer = (payer) => onResponse => {
    try {           
        axiosInstance
            .post(RELEASE_SINGLE_PAYER_URL, {payer: payer})
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) {
    }
};

export const createRoles = (name, permissions, reference_number, comments) => onResponse => {
    try {
        axiosInstance.post(CREATE_ROLES_URL, {
            name, permissions, reference_number, comments
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const editRoles = (role, name, permissions, reference_number, comments) => onResponse => {
    try {
        axiosInstance.post(CREATE_ROLES_URL, {
            role: role,
            name: name,
            permissions: permissions,
            reference_number: reference_number,
            comments: comments

        }
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSingleRoleDetails = (props) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_ROLE_DETAIL_URL + "?role=" + props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getGroupsForUser = () => onResponse => {
    try {
        axiosInstance.get(GET_GROUPS_FOR_USER_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getPermissions = () => onResponse => {
    try {
        axiosInstance.get(GET_PERMISSIONS_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const deleteRoles = (role, reference_number, comments) => onResponse => {
    try {
        axiosInstance.delete(DELETE_ROLES_URL, {
            data: { role, reference_number, comments }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getReasonCodes = (page, limit, search, status, updated_date_range, clients, data_from, sort_order, sort_key, lockbox_name, facility, deposite_date) => onResponse => {
    try {
        let data = search ? search : ''
        let approve = status ? status : ''
        const new_updated_date_range = updated_date_range ? updated_date_range : ""
        const new_sort_key = sort_key ? sort_key : ""
        const new_sort_order = sort_order ? sort_order : ""
        const new_clients = clients ? clients : []
        const new_data_from = data_from ? data_from : ""
        const new_lockbox_name = lockbox_name ? lockbox_name : ""
        const new_facility = facility ? facility : ""
        const new_deposite_date = deposite_date ? deposite_date : ""


        axiosInstance.get(GET_REASON_CODES_URL, {
            params: {
                page: page,
                limit: limit,
                search: data,
                is_approved: approve,
                updated_date_range: new_updated_date_range,
                clients: Array.isArray(new_clients) ? new_clients.join(",") : "",
                facility: Array.isArray(new_facility) ? new_facility.join(",") : "",
                data_from: new_data_from,
                sort_order: new_sort_order,
                sort_key: new_sort_key,
                lbx_file_name: new_lockbox_name,
                deposite_date_range: new_deposite_date,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const exportReasonCodes = (props) => onResponse => {
    const { search, status, updated_date_range, clients, data_from, sort_key, sort_order, lockbox_name, deposite_date } = props
    try {
        let data = search ? search : ''
        let approve = status ? status : ''
        const new_updated_date_range = updated_date_range ? updated_date_range : ""
        const new_sort_key = sort_key ? sort_key : ""
        const new_sort_order = sort_order ? sort_order : ""
        const new_clients = clients ? clients : []
        const new_data_from = data_from ? data_from : ""
        const new_lockbox_name = lockbox_name ? lockbox_name : ""
        const new_deposite_date = deposite_date ? deposite_date : ""

        axiosInstance.get(EXPORT_REASON_CODES_URL, {
            params: {
                search: data || '',
                is_approved: approve ?? '', // use ?? to include false
                updated_date_range: new_updated_date_range || '',
                clients: Array.isArray(new_clients) ? new_clients.join(',') : '',
                data_from: new_data_from || '',
                sort_order: new_sort_order || '',
                sort_key: new_sort_key || '',
                lbx_file_name: new_lockbox_name || '',
                deposite_date_range: new_deposite_date || ''
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const importCsvReasonCode = (props) => onResponse => {
    try {
        // console.log(csv_file);
        axiosInstance.post(GET_REASON_CODE_CSV_IMPORT_URL, props.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const importCsvPayeeCode = (props) => onResponse => {
    try {
        // console.log(csv_file);
        axiosInstance.post(GET_PAYEE_CSV_IMPORT_URL, props.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const importCsvPayerCode = (props) => onResponse => {
    try {
        // console.log(csv_file);
        axiosInstance.post(GET_PAYER_CSV_IMPORT_URL, props.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const importCsvX12Code = (props) => onResponse => {
    try {
        // console.log(csv_file);
        axiosInstance.post(GET_X12_CSV_IMPORT_URL, props.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


// ========PAYER ID LIST==========
export const createPayerIdList = (unique_code, data, payer_list_id, removed_ids, client) => onResponse => {
    let dict = { unique_code, data, removed_ids, client }
    if (payer_list_id) {
        dict = { unique_code, payer_list_id, data, removed_ids, client }
    }
    try {
        axiosInstance.post(CREATE_PAYER_ID_LIST_URL, dict)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const deletePayerIdList = (id) => onResponse => {
    try {
        axiosInstance.delete(DELETE_PAYER_ID_LIST_URL, {
            data: { payer_list_id: id }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSinglePayerIdList = (payer_list_id) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_PAYER_ID_LIST_DETAIL_URL + '?payer_list_id=' + payer_list_id)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getPayerIdList = (page, limit, search, updated_date_range, clients, sort_order, sort_key, facility) => onResponse => {
    try {
        let data = search ? search : ''
        const new_updated_date_range = updated_date_range ? updated_date_range : ""
        const new_sort_key = sort_key ? sort_key : ""
        const new_sort_order = sort_order ? sort_order : ""
        const new_clients = clients ? clients : []
        // const new_facility = facility ? facility : []


        axiosInstance.get(GET_ALL_PAYER_ID_LIST_URL, {
            params: {
                page: page,
                limit: limit,
                search: data,
                updated_date_range: new_updated_date_range,
                clients: new_clients.join(","),
                sort_order: new_sort_order,
                sort_key: new_sort_key,
            }
        })

            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const exportPayerIdList = (props) => onResponse => {
    const { search, updated_date_range, clients, sort_key, sort_order } = props
    try {
        let data = search ? search : ''
        const new_updated_date_range = updated_date_range ? updated_date_range : ""
        const new_sort_key = sort_key ? sort_key : ""
        const new_sort_order = sort_order ? sort_order : ""
        const new_clients = clients ? clients : []


        axiosInstance.get(EXPORT_PAYER_ID_LIST_URL + '?search=' + data + '&updated_date_range=' + new_updated_date_range + '&clients=' + new_clients + '&sort_order=' + new_sort_order + '&sort_key=' + new_sort_key)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const importCsvPayerIdList = (props) => onResponse => {
    try {
        // console.log(csv_file);
        axiosInstance.post(GET_PAYER_ID_LIST_CSV_IMPORT_URL, props.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
// ====================


export const createReasonCodes = (reason_code, payer_id, data, data_from, reasoncodes, removed_ids, is_approved, client, facility) => onResponse => {
    try {
        if (!facility || facility == "") {
            facility = [];
        }

        axiosInstance.post(CREATE_REASON_CODES_URL, { reason_code, payer_id, data, data_from, reasoncodes, removed_ids, is_approved, client, facility })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const createPropCode = (job, payer_id, last_name, n3_address_1, n4_city_name, n4_state_code, n4_postal_code, reason_code, data_from, description, rarc, carc, group_code) => onResponse => {
    try {
        axiosInstance.post(POST_PROP_CODE_CREATE_URL, {
            job, payer_id, last_name, n3_address_1, n4_city_name, n4_state_code, n4_postal_code, reason_code, data_from, description, rarc, carc, group_code
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const deleteReasonCodes = (id) => onResponse => {
    try {
        axiosInstance.delete(DELETE_REASON_CODES_URL, {
            data: { pk: id }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSingleReasonCode = (reasoncodes) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_REASON_CODE_URL + '?reasoncodes=' + reasoncodes)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const updateReasonCodes = (reasoncodes, reason_code, description, x12_code, identification_code) => onResponse => {
    try {
        axiosInstance.post(CREATE_REASON_CODES_URL, {
            reasoncodes, reason_code, description, x12_code, identification_code
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getX12Codes = (page, limit, description, code) => onResponse => {
    try {
        axiosInstance.get(GET_X12_CODES_URL, {
            params: {
                page: page,
                limit: limit,
                description: description,
                code: code
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const createX12Code = (type, code, description, start_date, stop_date) => onResponse => {
    try {
        axiosInstance.post(CREATE_X12_CODE_URL, {
            type, code, description, start_date, stop_date
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const toggleX12Code = (props) => onResponse => {
    try {
        axiosInstance.post(TOGGLE_X12_CODE_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSingleX12Code = (x12code) => onResponse => {
    console.log(x12code);
    try {
        axiosInstance.get(GET_SINGLE_X12_CODE_DROPDOWN_URL + '?x12code=' + x12code)
            .then((response) => {
                console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const updateX12Code = (pk, type, code, description, start_date, stop_date) => onResponse => {
    try {
        axiosInstance.post(CREATE_X12_CODE_URL, {
            pk, type, code, description, start_date, stop_date
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};




export const getCorrespondenceCategories = (page, limit, search = {},) => onResponse => {
    try {
        const { clients, facility, category, status, sort_key, sort_order } = search

        axiosInstance.get(GET_CORRESPONDENCE_CATEGORY, {
            params: {
                page: page,
                limit: limit,
                client: Array.isArray(clients) ? clients?.join(',') : "",
                facility: Array.isArray(facility) ? facility?.join(',') : "",
                search: category,
                status: status?.value,
                sort_key: sort_key,
                sort_order: sort_order
            }
        })

            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const createCorrespondenceCategory = (client, facility, categories) => onResponse => {
    try {
        axiosInstance.post(CREATE_CORRESPONDENCE_CATEGORY, {
            client, facility,
            categories

        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const deleteCorrespondenceCategory = (CorrespondenceCategory) => onResponse => {
    try {
        axiosInstance.delete(DELETE_CORRESPONDENCE_CATEGORY, {
            data: { CorrespondenceCategory: CorrespondenceCategory }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSingleCorrespondenceCategory = (id) => onResponse => {
    try {
        axiosInstance.get(GET_SINGLE_CORRESPONDENCE_CATEGORY + "?CorrespondenceCategory=" + id)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const updateCorrespondenceCategory = (id, client, facility, category) => onResponse => {
    try {
        axiosInstance.post(CREATE_CORRESPONDENCE_CATEGORY, {
            categories: [{
                id: id, category: category,
            }],
            client: client,
            facility: facility?.length > 0 ? facility : [],
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getX12CodeDropdown = (page) => onResponse => {
    try {
        axiosInstance.get(GET_X12_CODE_DROPDOWN_URL + "?page=" + page)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getPayerDropdown = (page, search) => onResponse => {
    try {
        axiosInstance.get(GET_PAYER_DROPDOWN + "?page=" + page + "&search=" + search)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getPayerDropdownV2 = (page, search, client) => onResponse => {
    try {
        axiosInstance.get(GET_PAYER_DROPDOWN_V2 + "?page=" + page + "&search=" + search + "&client=" + client)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getPdf = (client) => onResponse => {
    try {
        axiosInstance.get(GET_CLIENTS_PDF_URL + "?client=" + client)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getAllSettings = (page) => onResponse => {
    try {
        axiosInstance.get(GET_ALL_SETTINGS_URL + "?page=" + page)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getAllSettingsDropDown = (key) => onResponse => {
    try {
        axiosInstance.get(GET_ALL_SETTINGS_DROP_DOWN_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const updateSettings = (settings, comments) => onResponse => {
    try {
        console.log("REDUX_UPDATE_SETTINGS_PAYLOAD:", { settings, comments });
        axiosInstance.post(UPDATE_SETTINGS_URL, {
            settings,
            comments
        })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAllTimezone = () => onResponse => {
    try {
        axiosInstance.get(GET_ALL_TIMEZONE)
            .then((response) => {
                console.log(response);

                onResponse(response?.data)
            })
            .catch((err) => {
                onResponse(err)
            })
    } catch (error) {

    }
}

export const getSelectedTimezone = () => onResponse => {
    try {
        axiosInstance.get(GET_SELECTED_TIMEZONE)
            .then((response) => {
                onResponse(response?.data)
            })
            .catch((err) => {
                onResponse(err)
            })
    } catch (error) {

    }
}

export const getFacilityDropdown = (client) => onResponse => {
    try {
        axiosInstance.post(GET_CLIENT_FACILITY_URL, {
            client
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

//KEEP ALIVE API
export const getKeepAliveApi = () => onResponse => {
    try {
        axiosInstance.get(KEEP_ALIVE)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getFailedJobsXAuto = () => onResponse => {
    try {
        axiosInstance.get(GET_FAILED_JOBS_XAUTO_V2) //changed  the old api GET_FAILED_JOBS_XAUTO to new 
            .then((response) => {
                onResponse(response?.data)
            })
            .catch((err) => {
                onResponse(err)
            })
    } catch (error) {

    }
}
export const resoncodeToggleApi = (props) => onResponse => {

    try {
        axiosInstance.get(GET_REASON_CODES_ACTIVE + '?reason_code=' + props.reasoncodes_id)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSettingsLog = (page, limit, search) => onResponse => {
    try {
        let searchVal = '';
        let user = '';
        let updated_date_range = '';
        let settings_name = '';

        if (search && typeof search === 'object') {
            searchVal = search.search || '';
            if (Array.isArray(search.user)) {
                user = search.user.map(item => item?.value ?? item).join(',');
            } else if (search.user) {
                user = search.user;
            }
            updated_date_range = search.date || '';
            if (Array.isArray(search.settings_name)) {
                settings_name = search.settings_name.map(item => item.value).join(',');
            } else if (search.settings_name) {
                settings_name = search.settings_name;
            }
        } else {
            searchVal = search || '';
        }

        axiosInstance.get(GET_SETTINGS_LOG_URL, {
            params: {
                page: page,
                limit: limit,
                search: searchVal,
                user: user,
                updated_date_range: updated_date_range,
                settings_name: settings_name
            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getReasonCodesLog = ({ page, limit, reasoncode }) => onResponse => {
    try {
        axiosInstance.get(GET_REASON_CODES_LOG, {
            params: {
                page: page,
                limit: limit,
                reasoncode,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const togglePayerIDListLogs = (props) => onResponse => {
    try {
        axiosInstance.post(TOGGLE_PAYER_ID_LIST_URL, props.formData)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const CorrespondenceLog = ({ page, perPage, pk }) => onResponse => {

    try {
        axiosInstance.get(GET_CORRESPONDENCE_LOG, {

            params: {
                // user: props?.user,
                // updated_date_range: props?.updated_date_range,
                page: page,
                limit: perPage,
                id: pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const toggleCorrespondence = (id) => onResponse => {

    try {
        axiosInstance.post(GET_CORRESPONDENCE_ACTIVE_INACTIVE, { id: id })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);

            })
            .catch((err) => {
                onResponse(err);

            });

    } catch (error) {

    }

};
//userwise report list
export const getUserWiseReportListData = (props) => onResponse => {

    try {
        const module1 = props?.module ? props?.module : "";
        const user = props?.users ? props?.users : "";
        const updated_date_range = props?.deposit_date_range ? props?.deposit_date_range : "";

        axiosInstance.get(USER_WISE_REPORT_LIST_URL + "?page=" + props?.page + "&limit=" + props?.page_limit
            + "&module=" + module1 + "&updated_date_range=" + updated_date_range + "&user=" + user
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};